import React from "react"
import { connect } from "react-redux"
import { push as pushAction } from "connected-react-router"
import "./ScoopedCoolCard.less"
  
function cutName(s) {
  if (s.indexOf("(") > 0) {
    return s.split("(")[0]
  }
  else if (s.indexOf("（") > 0) {
    return s.split("（")[0]
  }
  else {
    return s
  }
}

const ScoopedCoolCard = ({ product, push, url = "" }) => (
 

  <div style={{position: "relative", width: "100%"}} className="scooped" onClick={() => push(url || `/catalogo/product/${product._id}`)}>
    <img src="/static/entrada_completo.svg" style={{width: "100%", filter: "drop-shadow(1px 1px 6px rgba(50,41,41,0.1))"}}></img>

    <div style={{display: "flex", width: "100%", height: "100%"}} className="content">
        
      <div style={{width: "25%", backgroundImage: `url(${product.foreground.image})`}} className="imagen"/>
      <div className="text">
        <div>{cutName(product.chName)}</div>
        <div>{product.address}</div>
        <div className="tags">
          <div className="price">
            {product.ppp || (product.price && product.price.general) || 0}
            欧/人
          </div>
          <div className="moreInfo">
            套餐内容 
            {' '}
            {">"}
          </div>
        </div>
        <div>{product.subtitle}</div>
        
      </div>
        
    </div>
  </div>

)

const mapStateToProps = (stateIgnored, ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(pushAction(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScoopedCoolCard)


// WEBPACK FOOTER //
// ./src/app/catalogo/components/ScoopedCoolCard.jsx